import { AppContext } from '@lightspeed-invoicing/core-client/frontend'
import $ from 'jquery'
import React, { Component } from 'react'
import { Button, Col } from "react-bootstrap"
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl'
import Icon from "../common/icon/icon.component"
import FormattedInputField from '../sharedComponents/formattedInputField.component.jsx'
import { DISCOUNT_TYPE } from '../state/pricing/DiscountType'

class DiscountQuote extends Component {

    constructor(props, context) {
        super(props, context);

        //options available in the unit selector
        this.selectOptions = {
            "empty": "Unit",
            "currencyAmount": this.props.currency,
            "percentage": "%"
        };

        this.state = {
            selectedOptionKey: this.props.selectedOptionKey,
            discountValue: this.props.discountValue,
            discountName: this.props.discountName,
            endPoint: this.getEndPoint(this.props),
            billingMethod: this.props.billingMethod || '',
            isDiscountCurrentlySet: this.props.isDiscountCurrentlySet, //had a discount already been applied
            removeDiscount: false,
        }

        this.onClose = this.props.onClose
        this.handleValueChange = this.handleValueChange.bind(this)
        this.handleUnitSelection = this.handleUnitSelection.bind(this)
        this.handleRemoveDiscountButton = this.handleRemoveDiscountButton.bind(this)
        this.closeModals = this.closeModals.bind(this)
        this.applyDiscountMainButton = this.applyDiscountMainButton.bind(this)
        this.applyDiscountUpdate = this.applyDiscountUpdate.bind(this)
        this.handleFocus = this.handleFocus.bind(this)
    }

    getEndPoint(props) {
        if (props.mainObject && props.objectId) {
            return '/' + props.mainObject + '/' + props.objectId + '/discount'
        }
        if (props.stockDocumentId){
            return '/stock-documents/' + props.stockDocumentId + '/discount'
        }
        return props.invoiceId ? '/invoices/' + props.invoiceId + '/discount' : '/quotes/' + props.quoteId + '/discount'
    }

    applyDiscountMainButton(event) {
        event.preventDefault()
        this.applyDiscountUpdate().then(_ => this.closeModals(event))
    }

    applyDiscountUpdate() {
        if (this.state.removeDiscount) {
            return AppContext.getApiClient().patch(this.state.endPoint, {
                discountType: "none",
                discountValue: "0",
                billingMethod: this.state.billingMethod,
            })
        }

        //define which default unit to use for the discount type selector
        var apiDiscountType = DISCOUNT_TYPE.DISCOUNT_CURRENCY_VALUE
        switch (this.state.selectedOptionKey) {
            case "percentage":
                apiDiscountType = DISCOUNT_TYPE.DISCOUNT_PERCENT_BEFORE_TAXES
                break;
            case "currencyAmount":
                apiDiscountType = DISCOUNT_TYPE.DISCOUNT_CURRENCY_VALUE
                break;
            case "empty":
                apiDiscountType = DISCOUNT_TYPE.DISCOUNT_NONE
                break;
        }

        return AppContext.getApiClient().patch(this.state.endPoint, {
            discountType: apiDiscountType,
            discountValue: this.state.discountValue,
            discountName: this.state.discountName,
            billingMethod: this.state.billingMethod,
        })
    }

    handleUnitSelection(event) {
        const target = event.target;
        this.setState({
            selectedOptionKey: target.value
        })
    }

    handleValueChange(event) {
        const target = event.target;
        this.setState({
            discountValue: target.value
        })
    }

    handleRemoveDiscountButton(event) {
        event.preventDefault()
        this.setState({
            removeDiscount: true,
            discountValue: '0',
        })
    }

    componentDidMount() {
        $('#applyDiscountModal').modal('show')
    }

    closeModals(event) {
        $('#applyDiscountModal').modal('hide')
        this.onClose()
    }

    handleFocus(event) {
        event.target.select()
    }

    render() {

        const messages = defineMessages({
            "name_placeholder": {
                id: 'quote.set_discount_modal.name_placeholder',
                defaultMessage: 'Discount name',
            }
        })
        return (
            <div>
                {/************** Discount quote Modal ***************/}
                <div className="modal fade"
                    id="applyDiscountModal"
                    role="dialog"
                    aria-labelledby="Add discount"
                    aria-hidden="true"
                    data-backdrop="static"
                    data-keyboard="false"
                >
                    <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title pb-0 mb-0 border-0" id="setDiscountModalLabel">
                                    <FormattedMessage
                                        id="quote.set_discount_modal.title"
                                        defaultMessage="Discount"
                                    />
                                </h5>
                                <button type="button" className="close" onClick={this.closeModals} aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>

                            <div className="modal-body">
                                <div className="container-fluid">
                                    <form className="row">
                                        {this.state.billingMethod === 'one-time' ? <Col xs={this.state.isDiscountCurrentlySet ? 5 : 6}>
                                            <input
                                                name="discountName"
                                                value={this.state.discountName}
                                                onChange={e => { this.setState({ discountName: e.target.value }) }}
                                                id="discountName"
                                                type="text"
                                                className="form-control mr-1"
                                                placeholder={this.props.intl.formatMessage(messages['name_placeholder'])}
                                            />
                                        </Col> : null}
                                        <Col xs={3}>
                                            <FormattedInputField
                                                id="discountValue"
                                                disabled={this.state.removeDiscount}
                                                type="text"
                                                className="form-control mr-1"
                                                placeholder="value"
                                                valueType="decimal"
                                                onFocus={this.handleFocus}
                                                onClick={this.handleFocus}
                                                value={this.state.discountValue}
                                                onValueChange={(newValue) => { this.setState({ "discountValue": newValue }) }}
                                            />
                                        </Col>
                                        <Col xs={3}>
                                            <select value={this.state.selectedOptionKey} className="custom-select mr-1" id="dropDownDiscountUnit" required onChange={this.handleUnitSelection} disabled={this.state.removeDiscount}>
                                                {Object.entries(this.selectOptions).map(([key, value]) => <option key={key} id={key} value={key}>{value}</option>)}
                                            </select>
                                        </Col>
                                        {this.state.isDiscountCurrentlySet && 
                                            <Col xs={1}>
                                                <Button variant="danger" className="mr-2" onClick={this.handleRemoveDiscountButton}>
                                                    <Icon value={"trash"} className={"pr-1"}/>
                                                </Button>
                                            </Col>}
                                    </form>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={this.closeModals}>
                                    <FormattedMessage
                                        id="quote.set_discount_modal.close_btn"
                                        defaultMessage="Close"
                                    />
                                </button>
                                <button type="button" className="btn btn-primary" onClick={this.applyDiscountMainButton}>
                                    <FormattedMessage
                                        id="quote.add_item_modal.apply_discount_btn"
                                        defaultMessage="Apply Discount"
                                    />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default injectIntl(DiscountQuote)





// WEBPACK FOOTER //
// ./src/quote/discount.component.jsx